export const SEARCH_FOR_CONTACT_POST = 'mac/FETCH_SEARCH_FOR_CONTACT_POST';
export const INVOICE_JSON_GET = 'mac/FETCH_INVOICE_JSON';
export const INVOICE_PDF = 'mac/FETCH_INVOICE_PDF';
